import { onBeforeUnmount, onMounted, ref } from "vue";
import { eventBus } from "@/main";
import EventCenter from "@/utils/EventCenter";
export default {
  __name: 'PackageLockedDialog',
  setup(__props) {
    const visible = ref(false);
    const openDialog = () => {
      visible.value = true;
    };
    const closeDialog = () => {
      visible.value = false;
    };
    onMounted(() => {
      eventBus.$on(EventCenter.openPackageLockedDialog, openDialog);
    });
    onBeforeUnmount(() => {
      eventBus.$off(EventCenter.openPackageLockedDialog, openDialog);
    });
    return {
      __sfc: true,
      visible,
      openDialog,
      closeDialog
    };
  }
};